module.exports = __webpack_public_path__ + "static/media/Boom.9d593be9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/Games/Sweeper/assets/Boom.gif
// module id = 130
// module chunks = 0